import React, { Component } from 'react';

class Resume extends Component {
  render() {

    if(this.props.data){
      var skillmessage = this.props.data.skillmessage;
      console.log("this.props.data.education",this.props.data.education[0].descriptions)
      var eduDescription = this.props.data.education[0].descriptions.map(function(eduDescription){
        return <div key={eduDescription.gpa}>
        <p className='no-margin'>GPA: {eduDescription.gpa} </p>
        <p className='no-margin'>Honors: {eduDescription.honors}</p>
        <p className='no-margin'>Deans List: {eduDescription.deanslist}</p>
        <p className='no-margin'>Additional Diploma: {eduDescription.additional}</p></div>
      })

      var education = this.props.data.education.map(function(education){
        return <div key={education.school}><h3>{education.school}</h3>
        <p className="info">{education.degree} <span>&bull;</span><em className="date">{education.graduated}</em></p>
        </div>
      })
      var work = this.props.data.work.map(function(work){
        var role = work.roles.map(function(role) {
          return <div>
                    <p className="res-item-role">{role.role}</p>
                    <p >{role.items.map(item => <p className="res-item-exp">{item.item}</p>)}</p>
                  </div>
        })

        return <div key={work.company}><h3>{work.company}</h3>
            <p className="info">{work.title}<span>&bull;</span> <em className="date">{work.years}</em></p>
            <p>{role}</p>
        </div>
      })
      var skills = this.props.data.skills.map(function(skills){
        var className = 'bar-expand '+skills.name.toLowerCase();
        return <li key={skills.name}><span style={{width:skills.level}}className={className}></span><em>{skills.name}</em></li>
      })
    }

    return (
      <section id="resume" class="three columns">

      <div className="row education">
         <div className="three columns header-col">
            <h1><span>Education</span></h1>
         </div>

         <div className="nine columns main-col">
            <div className="row item">
               <div className="twelve columns">
                 {education}
                 {eduDescription}
               </div>
            </div>
         </div>
      </div>


      <div className="row work">

         <div className="three columns header-col">
            <h1><span>Work</span></h1>
         </div>

         <div className="nine columns main-col">
          {work}
        </div>
    </div>



      <div className="row skill">

         <div className="three columns header-col">
            <h1><span>Skills</span></h1>
         </div>

         <div className="nine columns main-col">

            <p>{skillmessage}
            </p>

				<div className="bars">
				   <ul className="skills">
					  {skills}
					</ul>
				</div>
			</div>
      </div>
   </section>
    );
  }
}

export default Resume;
